import { render, staticRenderFns } from "./StatisticsSection.vue?vue&type=template&id=0612c325&scoped=true&"
import script from "./StatisticsSection.vue?vue&type=script&lang=js&"
export * from "./StatisticsSection.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsSection.vue?vue&type=style&index=0&id=0612c325&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612c325",
  null
  
)

export default component.exports